var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toJS } from "mobx";
export var RecallCheckBusiness = function (storeContainer) {
    var store = storeContainer.store;
    var _a = store.newCreateRequestStore, progressStore = _a.progressStore, problemStore = _a.problemStore, detailStore = _a.detailStore, questionsStore = _a.questionsStore, availabilityStore = _a.availabilityStore, homeStore = _a.homeStore, recallCheckStore = _a.recallCheckStore, commonStore = _a.commonStore, shareStore = store.shareStore;
    var propsConnect = {
        currentUser: homeStore.currentUser,
        level: problemStore.level,
        clientId: commonStore.clientId,
        levelOneAliasList: problemStore.levelOneAliasList,
        levelTwoAliasList: problemStore.levelTwoAliasList,
        levelThreeAliasList: problemStore.levelThreeAliasList,
        levelOneId: problemStore.levelOneId,
        levelOneName: problemStore.levelOneName,
        levelOneTwoId: problemStore.levelTwoId,
        levelTwoName: problemStore.levelTwoName,
        loading: problemStore.loading,
        problemCaseCadeName: toJS(problemStore.problemCaseCadeName),
        isAliasingView: problemStore.isAliasingView,
        recallEnvToggle: recallCheckStore.recallEnvToggle,
        lastLevel: problemStore.lastLevel,
        originWO: recallCheckStore.originWO,
        serviceCategoryId: problemStore.serviceCategoryId,
        recallWOList: recallCheckStore.recallWOList,
        screenWidth: recallCheckStore.screenWidth,
        screenLimit: recallCheckStore.screenLimit,
        serviceTypeId: problemStore.serviceTypeId,
        serviceCodeId: problemStore.serviceCodeId,
        recallWOsLoading: recallCheckStore.loading,
        isRecallCheck: commonStore.isRecallCheck,
        backUpWO: recallCheckStore.backUpWO,
        videoURL: problemStore.videoURL,
        howToVideoVisible: problemStore.howToVideoVisible,
    };
    var dispatchConnect = {
        setProblemLevel: problemStore.setProblemLevel,
        initProblem: problemStore.initProblem,
        jump: progressStore.jump,
        getClientServiceComboAlias: problemStore.getClientServiceComboAlias,
        setProblemAlias: problemStore.setProblemAlias,
        backLevelQuestion: problemStore.backLevelQuestion,
        clearAfterStepData: function () {
            questionsStore.clear();
            availabilityStore.clear();
            detailStore.clear();
        },
        setLevel: function (level) {
            problemStore.setProblemLevel(level);
            problemStore.backLevelQuestion(level);
        },
        reGetClientId: shareStore.reGetClientId,
        setLastLevel: problemStore.setLastLevel,
        recallUploadAttachment: recallCheckStore.uploadAttachment,
        recallDeleteAttachment: recallCheckStore.deleteAttachment,
        setOriginWO: recallCheckStore.setOriginWO,
        getRecallWOList: recallCheckStore.getRecallWOList,
        setScreenWidth: recallCheckStore.setScreenWidth,
        computeRecallWOList: recallCheckStore.computeRecallWOList,
        toggleWOAttachmentShow: recallCheckStore.toggleWOAttachmentShow,
        setRecallWOsLoading: recallCheckStore.setLoading,
        getServiceCodeWOType: problemStore.getServiceCodeWOType,
        setAdditionalDetail: detailStore.setAdditionalDetail,
        commonStoreSetParam: commonStore.setParam,
        setOriginWOData: function (tempWO) {
            detailStore.setDetailData(tempWO);
            problemStore.setProblemData(tempWO);
        },
        setTempWOData: function () {
            commonStore.setParam('isRecallCheck', true);
            recallCheckStore.setTempWOData({
                serviceCombinationAliasId: problemStore.serviceCombinationAliasId,
                currentIconUrl: problemStore.currentIconUrl,
                serviceCategoryId: problemStore.serviceCategoryId,
                serviceTypeId: problemStore.serviceTypeId,
                serviceCodeId: problemStore.serviceCodeId,
            });
        },
        revertProblemData: problemStore.revertProblemData,
        setHowToVideoVisible: problemStore.setHowToVideoVisible,
        setAvailabilityParam: function (key, value) { return availabilityStore.setParams(key, value); },
    };
    return __assign(__assign({}, propsConnect), dispatchConnect);
};
